<template>
    <v-card
        class="ma-4 pa-1"
        elevation="0"
    >
        <v-list-item dense>
            <v-list-item-content>
                <v-list-item-title class="card-title">{{ value.module_title | translate }}</v-list-item-title>
                <SmallCard :width="100" title="Module Progress" color="green" :value="(value.module_progress)?(value.module_progress):'Not Started' | translate"/>
                <SmallCard :width="100" title="Time Spent" color="blue" :value="(value.module_time_spent)?(value.module_time_spent):'No Time Spent' | translate"/>
                <SmallCard :width="100" title="Module Attempts" color="orange" :value="(value.module_attempts)?(value.module_attempts):'No Attempts' | translate"/>
                <v-divider></v-divider>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
export default {
    name: 'ModuleCard',
    props: {
        color: String,
        value: Object,
        width: Number,
    },
    components: {
        SmallCard: () => import("@/components/cards/SmallCard"),
    },
}
</script>

<style scoped>
.card-title{
    font-size: 20px;
}

.v-list-item {
    padding-left: 20px !important;
    color:"red";
}

</style>